import { PageTypeEnum, TableTypes } from '@/constant';
import { IRecommenderListItem } from '@/services';
import {
	IWorkerApplicantListStore,
	IWorkerFranchiseListItemStore,
	IWorkerLodgingListItemStore,
} from '@/stores';
import { convertDivisionRecommender, getDiffExpirationDate } from '@/utils';

import { isNilOrEmpty, isNonEmptyArray } from 'ramda-adjunct';

export const DOCUMENT_SEARCH_OPTIONS = [
	{
		value: TableTypes.AR1_01,
		label: '근로자',
		type: PageTypeEnum.APPLICANT,
	},
	{
		value: TableTypes.FR1_01,
		label: '고용주',
		type: PageTypeEnum.FRANCHISE,
	},
	{
		value: TableTypes.LM1_01,
		label: '숙소 주소',
		type: PageTypeEnum.LODGING,
	},
	{
		value: TableTypes.RM1_01,
		label: '추천자',
		type: PageTypeEnum.RECOMMENDER,
	},
];

export const getColumnsApplicant = (content: IWorkerApplicantListStore[]) => {
	if (!isNonEmptyArray(content)) return [];
	return content?.map((item) => ({
		id: {
			value: item?.id,
			className: 'w-max mr-2',
			label: 'ID.',
		},
		registDt: {
			value: item.applicantRegistDt,
			className: 'float-right mt-[0.556vw]',
		},
		applicantDistrictName: {
			value: `(${item.applicantDistrictName || '-'}) ${item.applicantFirstName ?? ''} ${item.applicantLastName}`,
			className: '!block w-[95%]',
		},
		applicantStatusName: {
			value: item.applicantStatusName,
			className: '!block',
			label: '근무 상태: ',
		},
		content: {
			value: '',
			className: '!block',
			callback: () => {
				const diffExpirationDate = getDiffExpirationDate(
					item.applicantDepartureDate || ''
				);
				const content =
					diffExpirationDate < 0
						? item.applicantDepartureDate || '-'
						: `[D-${diffExpirationDate}] ${item.applicantDepartureDate}`;
				return <p>출국 일자: {content}</p>;
			},
		},
	}));
};

export const getColumnsFranchise = (
	content: IWorkerFranchiseListItemStore[]
) => {
	if (!isNonEmptyArray(content)) return [];
	return content?.map((item) => ({
		id: {
			value: item?.id,
			className: 'w-max mr-2',
			label: 'ID.',
		},
		registDt: {
			value: item.franchiseRegistDt,
			className: 'float-right mt-[0.556vw]',
		},
		employer: {
			value: `(${item.franchiseDistrictName || '-'}) ${item.franchiseEmployerName}`,
			className: '!block !text-font2 !text-[15px] !font-semibold',
		},
		address: {
			value: item.franchiseAddress,
			className: '!block w-[90%]',
		},
		productionType: {
			value: item.franchiseProductionTypeDetail,
			className: '!block',
			label: '작물/수산물: ',
		},
		employerPhone: {
			value: item.franchiseEmployerPhone,
			className: '!block',
			label: '전화번호: ',
		},
	}));
};

export const getColumnsRecommender = (content: IRecommenderListItem[]) => {
	if (!isNonEmptyArray(content)) return [];
	return content?.map((item) => ({
		id: {
			value: item?.recommenderId,
			className: 'w-max mr-2',
			label: 'ID.',
		},
		registDt: {
			value: item.recommenderRegistDt,
			className: 'float-right mt-[0.556vw]',
		},
		recommenderName: {
			value: `(${convertDivisionRecommender(item?.recommenderType)}) ${item?.recommenderName}`,
			className: '!block',
		},
		recommenderPhone: {
			value: item.recommenderPhone,
			className: '!block',
			label: '전화번호: ',
		},
		recommenderSpouseName: {
			value: `${
				isNilOrEmpty(item?.recommenderSpouseName) &&
				isNilOrEmpty(item?.recommenderSpousePhone)
					? '-'
					: `${item?.recommenderSpouseName ?? '-'} (${item?.recommenderSpousePhone ?? '-'})`
			}`,
			className: '!block',
			label: '배우자: ',
		},
	}));
};

export const getColumnsLodging = (content: IWorkerLodgingListItemStore[]) => {
	if (!isNonEmptyArray(content)) return [];
	return content?.map((item) => ({
		id: {
			value: item?.id,
			className: 'w-max mr-2',
			label: 'ID.',
		},
		registDt: {
			value: item.lodgingRegistDt,
			className: 'float-right mt-[0.556vw]',
		},
		lodgingDistrictName: {
			value: `(${item?.lodgingDistrictName ?? '-'}) ${item?.lodgingAddress}`,
			className: '!block',
		},
		lodgingInspectionDate: {
			value: item.lodgingInspectionDate,
			className: '!block',
			label: '숙소 점검일: ',
		},
		recommenderSpouseName: {
			value: `${
				isNilOrEmpty(item?.lodgingProviderName) &&
				isNilOrEmpty(item?.lodgingProviderPhone)
					? '-'
					: `${item?.lodgingProviderName ?? '-'} (${item?.lodgingProviderPhone ?? '-'})`
			}`,
			className: '!block',
			label: '제공자: ',
		},
	}));
};

export const renderPageType = (category: TableTypes) => {
	switch (category) {
		case TableTypes.AR1_01:
			return PageTypeEnum.APPLICANT;
		case TableTypes.FR1_01:
			return PageTypeEnum.FRANCHISE;
		case TableTypes.RM1_01:
			return PageTypeEnum.RECOMMENDER;
		case TableTypes.LM1_01:
			return PageTypeEnum.LODGING;
		default:
			return PageTypeEnum.APPLICANT;
	}
};

export const renderNameRegistration = (
	category: TableTypes,
	itemChecked: any
) => {
	switch (category) {
		case TableTypes.AR1_01:
			return `${itemChecked?.applicantFirstName ?? ''} ${
				itemChecked?.applicantLastName ?? ''
			}`;
		case TableTypes.FR1_01:
			return itemChecked?.franchiseEmployerName ?? '-';
		case TableTypes.RM1_01:
			return itemChecked?.recommenderName ?? '-';
		case TableTypes.LM1_01:
			return itemChecked?.lodgingAddress ?? '-';
		default:
			return '-';
	}
};
